import client from './client';
import { unwrapData } from './response';

const normalizeSession = (payload = {}) => {
  const user = payload.user || payload.admin || payload.data?.user || payload.data?.admin || payload.data;
  const token = payload.token || payload.access_token || payload.data?.token || payload.data?.access_token;

  return {
    ...payload,
    user,
    token
  };
};

// Login para acceso admin
export const adminLogin = async (email, password) => {
  const response = await client.post('/auth/login', {
    email,
    password,
    admin_login: true,
  });
  return normalizeSession(response.data);
};

// Obtener datos del usuario actual
export const getCurrentUser = async () => {
  const response = await client.get('/auth/me');
  const data = unwrapData(response, null);
  return data?.user || data?.admin || data;
};

// Logout
export const logout = async () => {
  try {
    await client.post('/auth/logout');
  } catch (error) {
    console.error('Error en logout:', error);
  }
};

// Refresh token
export const refreshToken = async () => {
  const response = await client.post('/auth/refresh');
  return response.data;
};

export const requestPasswordRecovery = async (email, tenantId) => {
  const response = await client.post('/auth/password/recover', { email, tenant_id: tenantId });
  return response.data;
};
